import { SET_ACCEPT_COOKIE } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const setAcceptCookie = payload => ({
  type: SET_ACCEPT_COOKIE,
  payload,
});



// WEBPACK FOOTER //
// ./src/app/acceptCookies/actions.js